<template>
  <div class="unit">
    <div class="unit-imgs"
      :class="expanded ? 'imgs-expanded' : ''">
      <UnitPics :imgs="unit.images" :id="unit.id" @slideChanged="handleSlideChange"></UnitPics>
    </div>
    <UnitDetails :unit="unit" :expanded="expanded" :interested="interested" @interested="handleAction"></UnitDetails>
    <UnitActions :unit="unit" :expanded="expanded" :interested="interested" @handleAction="handleAction"></UnitActions>
  </div>
</template>

<script setup>
import UnitPics from "./unit-card/UnitPics.vue";
import UnitDetails from "./unit-card/UnitDetails.vue";
import UnitActions from "./unit-card/UnitActions.vue";
import { useSearchResultsStore } from '@/stores/useSearchResultsStore';
import { defineEmits } from "vue";

const props = defineProps({
  unit: { type: Object, required: true },
  expanded: { type: Boolean, required: false, default: false },
  interested: {type: Boolean, required: false, default: false},
});

const emit = defineEmits(["activateResult"]);

const { toggleUnitInterest } = useSearchResultsStore();

function handleSlideChange(bool) {
  if (bool) {
    emit("activateResult", props.unit.id);
  }
}

function handleAction(action) {
  switch (action) {
    case 'details':
      emit("activateResult", null);
      break;
    case 'more':
      window.open(props.unit.link, "_blank");
      break;
    case 'interested':
      toggleUnitInterest(props.unit);
      break;
  }
}
</script>

<style>
.unit {
  flex-grow: 1;
  min-width: 336px;
  width: 336px;
  max-width: 336px;
  height: 180px;
  border-radius: 6px;
  margin-left: 15px;
  overflow: hidden;
  position: relative;
}

.unit-imgs {
  max-width: 270px;
  width: 150px;
  height: 100%;
  /* height: 180px; */
  box-shadow: 4px 0px 10px 0 rgba(0, 0, 0, 0.3);
  transition: width 0.15s ease-out;
  z-index: 2;
  position: relative;
  background-color: white
}

.imgs-expanded {
  width: 270px;
  box-shadow: none;
}

.not-expandable-unit-image {
  width: 50px;
  height: 50px;
  border-radius: 4px;
  box-shadow: none;
}
</style>